@if (dataService.connectionLinkType !== null) {
  <div id="paymentComplete" class="header container kompakt">
    @if (!dataService.isKompakt()) {
      @if (_contractorName) {
        <h1 class="text-center fw-bold text-uppercase mb-0">{{ _contractorName }}</h1>
      }
      <img src="assets/banner/PrivatemedNext-banner-640-kep.png" class="kompakt-img">
    }
    @if (dataService.isKompakt()) {
      <img src="assets/banner/Kompakt-banner-640-kep.png" class="kompakt-img">
    }
    @if (this.paymentProcessEnded) {
      <div class="row pt-5 details-row">
        <div class="col-12">
          <div class="icons mb-3">
            <fa-icon class="faCreditCard" [icon]="faCreditCard"></fa-icon>
            @if (this.paymentSuccessful) {
              <fa-icon class="faCheckCircle response-indicator" [icon]="faCheckCircle"></fa-icon>
            }
            @if (!this.paymentSuccessful) {
              <fa-icon class="faTimesCircle response-indicator" [icon]="faTimesCircle"></fa-icon>
            }
          </div>
          @if (this.paymentSuccessful) {
            <h1 class="text-center m-0">{{ 'paymentComplete.paymentOK' | translate }}</h1>
          }
          @if (!this.paymentSuccessful) {
            <h1 class="text-center m-0">{{ 'paymentComplete.paymentNotOK' | translate }}</h1>
          }
          @if (this.paymentSuccessful) {
            <p class="text-center fw-bold mt-2">{{ 'paymentComplete.feedback' | translate }}</p>
          }
          <div class="details mt-4">
            <span class="fw-bold me-2">{{ 'paymentComplete.contractGroupName' | translate }}:</span>
            <span class="mb-0"> {{this.insuredPerson.contractGroupName}}</span>
            @if (this.insuredPerson.contractGroupSubName) {
              <span> - {{this.insuredPerson.contractGroupSubName}}</span>
            }
            <br>
              <span class="fw-bold me-2">{{ 'paymentComplete.paymentTransactionCode' | translate }}:</span>
              <span> {{this.insuredPerson.paymentTransactionCode}}</span>
              <br>
                <span class="fw-bold me-2">{{ 'paymentComplete.offerNumber' | translate }}:</span>
                <span> {{this.insuredPerson.offerNumber}}</span>
                <br>
                  <span class="fw-bold me-2">{{ 'paymentComplete.frequencyFee' | translate }}:</span>
                  <span> {{this.formatCurrency(this.insuredPerson.frequencyFee)}} Ft</span>
                  @if (!this.paymentSuccessful) {
                    <button type="button" class="btn pay-button mt-5 mx-auto" (click)="restartPayment()">{{ 'paymentComplete.tryAgain' | translate }}</button>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
